/**
 * @class ModifyResult
 */
class ModifyResult {
  constructor(params) {
    let result = {
      feature: params.feature,
      features: params.features,
      target: params.target,
      type: "modify"
    };
    return result;
  }
}

module.exports = ModifyResult;